import React from 'react'
import { LOGO_IMG, USERBACK_ICON, USERLOGOUT_ICON } from '../../../utills/image-constant'
import { ROUTES } from '../../routes/url-constant';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { adminLogout } from '../../../services/api-services';
import { clearAccessTokenReducer } from '../../hooks/redux/slice/access-token';
import { clearLoggedUserReducer } from '../../hooks/redux/slice/logged-user';
import { toastEmitter } from '../../../utills/utilities';

const OnSiteAssessmentTopBar = () => {
    const dispatch = useDispatch();
    const Token = useSelector((state) => state?.accessToken?.value);
    const navigate = useNavigate();
    // useEffect(() => {
    //     const clickOutside = () => {
    //         setShowDropmenu(false);
    //     }
    //     document.addEventListener('click', clickOutside);
    //     return () => document.removeEventListener('click', clickOutside);
    // }, []);

    const handleAdminLogout = async () => {
        try {
            const response = await adminLogout(Token);
            if (response?.status === 200) {
                toastEmitter("success", "Admin Logout Successfully");
                dispatch(clearAccessTokenReducer());
                dispatch(clearLoggedUserReducer());
                localStorage.removeItem("RoleValue")
                localStorage.removeItem("DimesionMenegmentModalId")
                localStorage.removeItem("sub-DimesionMenegmentModalId");
                localStorage.removeItem("sub-DimesionMenegmentDimesionId");
                localStorage.removeItem("criteriaMenegmentModalId");
                localStorage.removeItem("criteriaMenegmentDimesionId");
                localStorage.removeItem("criteriaMenegmentSubDimesionId");
                localStorage.removeItem("ViewAssesmentCompanyId")
                localStorage.removeItem("OnsiteCompanyId")
                navigate(ROUTES.ADMINLOGINPAGE);
            }
        } catch (err) {
            console.error("Error fetching role data", err);
        }
    };
    const handleBack = () => {
        navigate(ROUTES.ONSITE);
    }
    return (
        <div><div
            className={`topbar-userTest d-flex align-items-center justify-content-between py-2 cmn-shadow shadow-sm`}
        >
            {/* LEFT — Logo + Sidebar Toggle */}
            <div className="d-flex align-items-center">
                <div
                    className="cursor-pointer"
                // onClick={() => setSidebarCollapse((prev) => !prev)}
                >
                    {/* {sidebarCollapse ? <SIDEBARMENU right={true} /> : <SIDEBARMENU />} */}
                </div>
                <img
                    src={LOGO_IMG}
                    alt="Logo"
                    className="full-logo"
                />
            </div>

            {/* CENTER — Project Name */}
            <div className="text-center flex-grow-1">
                <h5 className="m-0 fw-semibold ">Project Name / User Name</h5>
            </div>

            <div className=''>
                <img className='me-3 cursor-pointer ' src={USERBACK_ICON} alt='' onClick={handleBack} />
                <img className='cursor-pointer ' src={USERLOGOUT_ICON} alt='' onClick={handleAdminLogout} />
            </div>


        </div>
        </div>
    )
}

export default OnSiteAssessmentTopBar